export default "__VITE_ASSET__8PvY$BvU__"